(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ep-shop"]) return;
  try {
    
if (!customElements.get('lf-ep-product')) {
  customElements.define('lf-ep-product', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.select = this.querySelector('[data-ep-select]');
      this.panels = [...this.querySelectorAll('[data-ep-panel]')];
      this.formats = [...this.querySelectorAll('[data-ep-format]')];
      if (!this.select || !this.panels.length) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.querySelector('[data-ep-controls]').hidden = false;
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-ep-select], [data-ep-format]')) return;
        const format = this.formats.find(input => input.checked)?.value || 'score';
        if (this.closest('[data-product-section]').dataset.cartPending === 'true') {
          this.show(this.activeKey, this.activeFormat, false);
          return;
        }
        this.show(this.select.value, format, true);
      }, { signal });
      this.addEventListener('submit', event => {
        const form = event.target;
        const panel = form.closest('[data-ep-panel]');
        const option = form.closest('[data-ep-format-panel]');
        const input = form.querySelector('[data-ep-variant-input]');
        if (!panel || panel.hidden || !option || option.hidden || !input?.value || input.disabled) event.preventDefault();
      }, { signal });
      const fromURL = () => {
        const url = new URL(location.href);
        let key = url.hash.slice(1);
        let format = url.searchParams.get('format') || 'score';
        if (!key && url.searchParams.has('variant')) {
          const variant = [...this.querySelectorAll('[data-ep-variant]')].find(node => node.dataset.epVariant === url.searchParams.get('variant'));
          if (variant) { key = variant.closest('[data-ep-panel]').dataset.epPanel; format = variant.dataset.epFormatPanel; }
        }
        this.show(key, format, false);
      };
      window.addEventListener('popstate', fromURL, { signal });
      window.addEventListener('hashchange', fromURL, { signal });
      fromURL();
    }
    show(key, format, updateURL) {
      const selected = this.panels.find(panel => panel.dataset.epPanel === key) || this.panels[0];
      if (!this.formats.some(input => input.value === format)) format = 'score';
      this.activeKey = selected.dataset.epPanel;
      this.activeFormat = format;
      this.select.value = selected.dataset.epPanel;
      this.formats.forEach(input => { input.checked = input.value === format; });
      this.panels.forEach(panel => {
        const active = panel === selected;
        if (!active) panel.querySelectorAll('audio').forEach(audio => { if (!audio.paused) audio.pause(); });
        panel.hidden = !active;
        panel.querySelectorAll('[data-ep-format-panel]').forEach(option => {
          option.hidden = option.dataset.epFormatPanel !== format;
          option.querySelectorAll('[data-ep-variant-input]').forEach(input => { input.disabled = !active || option.hidden; });
        });
      });
      const option = selected.querySelector('[data-ep-format-panel]:not([hidden])');
      const price = this.querySelector('[data-ep-price-display]');
      price.textContent = option?.dataset.epPrice || price.dataset.startingPrice;
      this.querySelector('[data-ep-status]').textContent = selected.dataset.epTitle + ' · ' + this.formats.find(input => input.checked).nextElementSibling.textContent;
      if (updateURL) {
        const url = new URL(location.href);
        url.hash = selected.dataset.epPanel;
        url.searchParams.set('format', format);
        url.searchParams.delete('option_values');
        if (option?.dataset.epVariant) url.searchParams.set('variant', option.dataset.epVariant);
        else url.searchParams.delete('variant');
        history.pushState(history.state, '', url);
      }
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  function initializeContactSections(container) {
    container.querySelectorAll('[data-contact-section]').forEach((section) => {
      if (section.dataset.contactInitialized) return;
      section.dataset.contactInitialized = 'true';
      const subject = section.querySelector('[data-contact-subject]');
      const booking = section.querySelector('[data-booking-panel]');
      const bookingFields = section.querySelector('[data-booking-fields]');
      const courses = section.querySelector('[data-course-panel]');
      const message = section.querySelector('textarea[name="contact[body]"]');
      const messageLabel = section.querySelector('[data-message-label]');
      const serviceField = section.querySelector('[data-contact-service]');
      const date = section.querySelector('[data-course-date]');
      const timezone = section.querySelector('[data-course-timezone]');
      const parameters = new URLSearchParams(location.search);
      const returnedForm = Boolean(section.querySelector('[data-contact-status]'));
      const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
      const requestedSubject = parameters.get('subject')?.trim();
      if (requestedSubject && !subject.value && !returnedForm) {
        const aliases = {booking:'performance', 'cours en ligne':'lessons', 'visioconference':'lessons', 'online lessons':'lessons', 'video consultation':'lessons', video:'lessons'};
        const requested = normalize(requestedSubject);
        const option = Array.from(subject.options).find(item => item.value && (normalize(item.value) === requested || item.dataset.subjectType === (aliases[requested] || requested)));
        if (option) subject.value = option.value;
      }
      const requestedService = Array.from((parameters.get('service') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim()).slice(0, 160).join('');
      let generatedMessage = '';
      if (requestedService && !returnedForm) {
        serviceField.value = requestedService;
        serviceField.disabled = false;
        if (!message.value.trim()) {
          generatedMessage = (section.dataset.serviceMessage || '__service__').replace('__service__', requestedService);
          message.value = generatedMessage;
        }
      }
      function updateDateMinimum() {
        let today;
        try {
          const parts = new Intl.DateTimeFormat('en', {timeZone:timezone.value || undefined,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
          const part = type => parts.find(item => item.type === type).value;
          today = `${part('year')}-${part('month')}-${part('day')}`;
        } catch {
          const now = new Date();
          today = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
        }
        date.min = today;
      }
      function updateForm() {
        const type = subject.options[subject.selectedIndex]?.dataset.subjectType;
        const isCourse = type === 'lessons' || type === 'in_person';
        const isBooking = type === 'performance';
        booking.hidden = !isBooking;
        bookingFields.disabled = !isBooking;
        courses.hidden = !isCourse;
        courses.querySelectorAll('fieldset').forEach(fieldset => {
          const active = isCourse && (!fieldset.dataset.courseMode || fieldset.dataset.courseMode === type);
          fieldset.disabled = !active;
          fieldset.hidden = Boolean(fieldset.dataset.courseMode) && !active;
          fieldset.querySelectorAll('[data-course-required]').forEach(input => { input.required = active; });
        });
        message.required = !isCourse;
        messageLabel.textContent = isCourse ? messageLabel.dataset.optionalLabel : messageLabel.dataset.requiredLabel;
        if (isCourse && !timezone.value) timezone.value = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Paris';
        updateDateMinimum();
      }
      subject.addEventListener('change', () => {
        if (message.value === generatedMessage) message.value = '';
        serviceField.value = '';
        serviceField.disabled = true;
        updateForm();
      });
      timezone.addEventListener('change', updateDateMinimum);
      window.addEventListener('pageshow', updateForm);
      section.querySelector('form').addEventListener('submit', updateDateMinimum);
      updateForm();
      const status = section.querySelector('[data-contact-status]');
      if (status) status.focus({preventScroll:true});
    });
  }
  initializeContactSections(document);
  document.addEventListener('shopify:section:load', (event) => initializeContactSections(event.target));

  } catch(e) { console.error(e); }
})();
})();
